import React from 'react'
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";

import NotificationSettings from './NotificationSettings'

export default class DisableAllEmailNotifications extends NotificationSettings
{
    static path = '/settings/notifications/all/opt-out';
}

const DisableAllEmailNotificationsPage = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    let [searchParams] = useSearchParams();

    return (
        <DisableAllEmailNotifications location={location} 
            navigate={navigate} 
            queryParams={Object.fromEntries([...searchParams])}/>
    )
}

export {
    DisableAllEmailNotificationsPage,
}